import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule, MatTooltipModule } from '@angular/material';
import { PipesModule } from '@fuse/pipes/pipes.module';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { DialogQuotationComponent } from 'app/main/quotations/dialog/dialog-quotation.component';
import { DialogQuotationModule } from 'app/main/quotations/dialog/dialog-quotation.module';
import { ShowDataInputModule } from '../../../../../../core/components/show-data-input/show-data-input.module';
import { StarsModule } from '../logs/stars/stars.module';
import { TabQuotationsComponent } from './tab-quotations.component';


@NgModule({
  entryComponents: [
    TabQuotationsComponent,
    DialogQuotationComponent
  ],
  declarations: [
    TabQuotationsComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    FuseSharedModule,
    MatIconModule,
    ShowDataInputModule,
    StarsModule,
    PipesModule,
    MatTooltipModule,
    DialogQuotationModule
  ],
  exports: [
    TabQuotationsComponent
  ]
})
export class TabQuotationsModule {
}
